// tslint:disable:jsx-no-lambda
import { Cooltip, Icon } from '@abb/common-ux';
import { MySparePartsDonut } from '@module/shared/components/Donut/MySparePartsDonut';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IConnectedComponent } from 'reducers';
import { RequestModal } from '../Request';

interface IAnalysisProps {
  totalParts: number;
  matchedParts: number;
  unMatchedParts: number;
  sparePartsUploadID: string;
  isUploadSuccessful: boolean;
  isRequestModalOpen: boolean;
  onGetFullReportClick: () => void;
  onCloseRequestModal: () => void;
}

class AnalysisComponent extends React.Component<IConnectedComponent & IAnalysisProps> {
  constructor(props: IConnectedComponent & IAnalysisProps) {
    super(props);
    this.state = {
      isRequestModalOpen: false
    };
  }

  render() {
    const img = 'sampleMySparePartsReport.jpg';
    return (
      <div>
        <div className='row' style={{ display: this.props.isUploadSuccessful ? 'block' : 'none' }}>
          <div className='col-sm-12' style={{ marginTop: '7px' }}>
            <div className='getStartedTile'>
              <div className='row'>
                <div className='col-sm-6'>
                  <h3>
                    <b>Initial Analysis</b>
                  </h3>
                  <div className='row'>
                    <div className='col-sm-7' style={{ height: '400px', float: 'left' }}>
                      <MySparePartsDonut matched={this.props.matchedParts}
                        unmatched={this.props.unMatchedParts} />
                    </div>
                    <div className='col-sm-1' />
                    <div className='col-sm-4'>
                      <br />
                      <div>
                        <span style={{ fontSize: '13px', color: '#686868' }}>Submitted </span>
                        <Cooltip tooltipType='default' tooltipContents={<span>Unique parts identified.</span>} placement='topLeft' >
                          <Icon icon='information_circle2' color='#87d2ff' />
                        </Cooltip>
                        <p style={{ fontSize: '13px', color: '#1F1F1F' }}>{this.props.matchedParts + this.props.unMatchedParts}</p>
                      </div>
                      <br />
                      <div>
                        <span style={{ fontSize: '13px', color: '#686868' }}>Matched </span>
                        <Cooltip tooltipType='default' tooltipContents={<span>Identified as ABB part numbers (exact matches only).</span>} placement='topLeft' >
                          <Icon icon='information_circle2' color='#87d2ff' />
                        </Cooltip>
                        <p style={{ fontSize: '13px', color: '#1F1F1F' }}>{this.props.matchedParts}</p>
                      </div>
                      <br />
                      <div>
                        <span style={{ fontSize: '13px', color: '#686868' }}>Unmatched </span>
                        <Cooltip tooltipType='default' tooltipContents={<span>Unmatched parts could not be identified as ABB part numbers. If you feel this is not an accurate representation of your non-ABB parts inventory, please revisit your upload.</span>} placement='topLeft' >
                          <Icon icon='information_circle2' color='#87d2ff' />
                        </Cooltip>
                        <p style={{ fontSize: '13px', color: '#1F1F1F' }}>{this.props.unMatchedParts}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-sm-6'>
                  <h3>
                    <b>Sample Report</b>
                  </h3>
                  <img src={img} alt='Sample Report Image' width='100%' className='customBoxShadow' />
                </div>
              </div>
            </div>
          </div>
        </div>
        <RequestModal
          isOpen={this.props.isRequestModalOpen}
          dispatch={this.props.dispatch}
          history={this.props.history}
          sparePartsUploadID={this.props.sparePartsUploadID}
          onClose={this.props.onCloseRequestModal}
        />
      </div>
    );
  }
}

export const Analysis = withRouter(connect<any, IAnalysisProps, any>(mapStateToProps)(AnalysisComponent as any));

function mapStateToProps(store: any) {
  return {
    totalParts: store.uploadState.uploadResultStatus.TotalParts,
    matchedParts: store.uploadState.uploadResultStatus.MatchedParts,
    unMatchedParts: store.uploadState.uploadResultStatus.UnMatchedParts,
    sparePartsUploadID: store.uploadState.uploadResultStatus.SparePartsUploadID
  };
}
